const NON_EMBEDDABLE_HOST_SNIPPETS = [
  // Microsoft 365 - Word, Excel, PowerPoint online & Office web viewers
  'sharepoint.',
  '.sharepoint.com',
  'onedrive.',
  '1drv.ms',
  'office.com',
  'office365.com',
  'officeapps.live.com',
  'officeapps.microsoft.com',
  'view.officeapps.live.com',
  'word-view.officeapps',
  'excel.officeapps',
  'powerpoint.officeapps',
  'word-edit.officeapps',
  'excel-edit.officeapps',
  'outlook.office',
  'teams.microsoft.com',
  'forms.office.com',
  'microsoftstream.com',
  // Google Workspace - Docs, Sheets, Slides, Drive
  'drive.google.com',
  'docs.google.com',
  'sheets.google.com',
  'slides.google.com',
  'googleusercontent.com',
  'storage.googleapis.com',
  // Apple iCloud
  'icloud.com',
  // Dropbox, Box & enterprise file shares
  'dropbox.com',
  'box.com',
  'boxcloud.com',
  'sharefile.com',
  'egnyte.com',
  'sync.com',
  'pcloud.com',
  'mega.nz',
  'mega.io',
  'mediafire.com',
  'wetransfer.com',
  'hightail.com',
  // Zoho, Adobe & other document clouds
  'workdrive.zoho',
  'zohoexternal.com',
  'previewengine.zoho',
  'adobe.com',
  'documentcloud.adobe.com',
  'acrobat.adobe.com',
  'workdocs.',
  // Collaboration / design (often block embeds)
  'notion.so',
  'notion.site',
  'figma.com',
  'linkedin.com',
  'atlassian.net',
  'confluence.',
  'jira.',
]

/**
 * Returns false for hosts that typically block embedding (X-Frame-Options / CSP),
 * e.g. SharePoint, OneDrive, Office web viewers, Google Docs/Sheets/Drive, iCloud, Box.
 */
export const isUrlEmbeddableInIframe = (url: string): boolean => {
  try {
    const host = new URL(url).hostname.toLowerCase()
    return !NON_EMBEDDABLE_HOST_SNIPPETS.some((snippet) => host.includes(snippet))
  } catch {
    return false
  }
}
